import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import * as actions from '../redux/timeoff_request_modal_actions';

export class CancelRequestConfirmationModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        }
        
        this.doNotCancelTimeOff = this.doNotCancelTimeOff.bind(this)
        this.cancelTimeOffRequest = this.cancelTimeOffRequest.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.showModal !== this.props.showModal) {
            this.setState({
                showModal: nextProps.showModal,                
            })
        }   

        if(this.state.showModal && this.props.timeOffResponse !== nextProps.timeOffResponse) {
            this.setState({
                showModal: false
            })
            this.props.hideTimeOffModal()
        }
    }

    cancelTimeOffRequest() {
        this.props.actions.requestTimeOffCancelAction({requestID: this.props.requestID})        
    }

    doNotCancelTimeOff() {
        this.setState({
            showModal: false
        })
        this.props.hideCancelModalEvent()        
    }

    render() {
        var modalStyle = {                    
            width: '450px'           
        };
        
        var overlayStyle = { zIndex: 9} 
    
        return(
            <div className="modal_wrapper_cancel">                           
                <ReactModal
                    isOpen={this.state.showModal}                    
                    style={{
                        content:modalStyle,
                        overlay: overlayStyle
                    }}                 
                    className='time_off_modal cancel_modal' > 
                    <div className="modal_header">
                            Cancel Request
                    </div>
                    <div className="modal_body">
                        A cancelled time off request cannot be recovered. Proceed?
                    </div>
                     <div className="modal_footer cf">
                            <span className="footer button"> 
                                <span className="cancel_text" onClick={this.doNotCancelTimeOff}>No </span>
                                <button className="cf-button cf-button-blue" type="button"  onClick={this.cancelTimeOffRequest}>Yes</button>
                            </span>
                        </div>
                </ReactModal>                    
            </div>
        )
    }
}

function mapStateToProps(state) {
	return {
        timeOffResponse: state.timeoff.timeOffResponse,  
    };
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch)
	};
}

export default connect(	
    mapStateToProps,
	mapDispatchToProps
)(CancelRequestConfirmationModal);


// WEBPACK FOOTER //
// ./src/features/timeoff/Modals/CancelRequestConfirmationModal.js